import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__ from "@radix-ui/react-slot";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__ from "react-hook-form";
import * as __WEBPACK_EXTERNAL_MODULE__label_index_js_2049cd83__ from "../label/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__context_js_80e2871f__ from "./context.js";
import * as __WEBPACK_EXTERNAL_MODULE__use_form_field_js_ea4a5ddd__ from "./use-form-field.js";
const Form = __WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__.FormProvider;
function FormField({ ...properties }) {
    const value = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            name: properties.name
        }), [
        properties.name
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__context_js_80e2871f__.formFieldContext.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__.Controller, {
            ...properties
        })
    });
}
const FormItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>{
    const id = __WEBPACK_EXTERNAL_MODULE_react__.useId();
    const value = __WEBPACK_EXTERNAL_MODULE_react__.useMemo(()=>({
            id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__context_js_80e2871f__.formItemContext.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            ref: reference,
            className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('flex flex-col space-y-1.5', className),
            ...properties
        })
    });
});
FormItem.displayName = 'FormItem';
const FormLabel = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>{
    const { error, formItemId } = (0, __WEBPACK_EXTERNAL_MODULE__use_form_field_js_ea4a5ddd__.useFormField)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__label_index_js_2049cd83__.Label, {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)(error && 'text-destructive', className),
        htmlFor: formItemId,
        ...properties
    });
});
FormLabel.displayName = 'FormLabel';
const FormControl = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ ...properties }, reference)=>{
    const { error, formItemId, formDescriptionId, formMessageId } = (0, __WEBPACK_EXTERNAL_MODULE__use_form_field_js_ea4a5ddd__.useFormField)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot, {
        ref: reference,
        id: formItemId,
        "aria-describedby": error ? `${formDescriptionId} ${formMessageId}` : formDescriptionId,
        "aria-invalid": Boolean(error),
        ...properties
    });
});
FormControl.displayName = 'FormControl';
const FormDescription = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>{
    const { id, formDescriptionId } = (0, __WEBPACK_EXTERNAL_MODULE__use_form_field_js_ea4a5ddd__.useFormField)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
        ref: reference,
        id: id ? formDescriptionId : void 0,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('text-[0.8rem] text-muted-foreground', className),
        ...properties
    });
});
FormDescription.displayName = "FormDescription";
const FormMessage = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, children, ...properties }, reference)=>{
    const { error, formMessageId } = (0, __WEBPACK_EXTERNAL_MODULE__use_form_field_js_ea4a5ddd__.useFormField)();
    const body = error ? String(error?.message ?? '') || children : children;
    if (!body) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
        ref: reference,
        id: formMessageId,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('text-[0.8rem] font-medium text-destructive', className),
        ...properties,
        children: body
    });
});
FormMessage.displayName = 'FormMessage';
export { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage };

//# sourceMappingURL=index.js.map